import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyProduct = Loadable({
    loader: () => import("pages/Product/index"),
    loading: () => <PageLoader />,
});

const LazyProductForm = Loadable({
    loader: () => import("pages/ProductForm/index"),
    loading: () => <PageLoader />,
});

const LazyHargaDinamis = Loadable({
    loader: () => import("pages/HargaDinamis/index"),
    loading: () => <PageLoader />,
});


function ProductRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyProduct />} />
            <Route path="/add" element={<LazyProductForm type="new" />} />
            <Route path="/edit/:product_id" element={<LazyProductForm type="edit" />} />
            <Route path="/dynamic-pricing" element={<LazyHargaDinamis />} />
        </Routes>
    );
}

export default ProductRoute;
